import React from "react";

function DHT11Sensor() {
  return (
    <div>

      <h2>DHT11 Interfacing with Raspberry Pi</h2>

      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/331/icon/DHT11%20Interfacing%20with%20Raspberry%20Pi.jpg"
        alt="DHT11 Sensor"
        style={{
          width: "600px",
          margin: "20px 0",
          borderRadius: "10px",
          display: "block"
        }}
      />

      <h3>Overview of DHT11 Sensor</h3>
      <img
        src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/331/description/DHT11%20Sensor.png"
        alt="DHT11 Sensor"
        style={{
          width: "600px",
          margin: "20px 0",
          borderRadius: "10px",
          display: "block"
        }}
      />
      

      <h3>DHT11 Sensor Module</h3>

<ul>
  <li>
    The DHT11 sensor measures and provides humidity and temperature values 
    serially over a single wire.
  </li>
  <li>
    It can measure relative humidity in the range of 20% to 90% RH.
  </li>
  <li>
    It measures temperature in the range of 0°C to 50°C.
  </li>
  <li>
    The sensor has 4 pins, out of which one pin is used for serial data communication.
  </li>
  <li>
    Data is transmitted using pulses of different TON and TOFF, which are decoded 
    as logic 1, logic 0, start pulse, or end of a frame.
  </li>
</ul>

<p>
  For more information about the DHT11 sensor and how to use it, refer to the 
  <strong>DHT11 Sensor Module</strong> in the sensors and modules section.
</p>

<h3>Connection Diagram of DHT11 with Raspberry Pi</h3>

<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/331/description/RiPi%20interfacing%20with%20DHT11.png"
  alt="DHT11 Raspberry Pi Connection Diagram"
  style={{
    width: "600px",
    margin: "20px 0",
    borderRadius: "10px",
    display: "block"
  }}
/>

<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/331/description/Connections%20DHT11%20Interfacing%20with%20Raspberry%20Pi.jpg"
  alt="DHT11 Wiring Connections"
  style={{
    width: "600px",
    margin: "20px 0",
    borderRadius: "10px",
    display: "block"
  }}
/>

<h3>Read Temperature and Humidity using DHT11 with Raspberry Pi</h3>

<p>
  In this example, we interface the DHT11 sensor with Raspberry Pi 3 
  to read and display humidity and temperature values on the terminal.
</p>

<p>
  We use the <strong>Adafruit DHT Sensor Python library</strong>, which supports 
  sensors like DHT11, DHT22, and AM2302.
</p>

<h3>Installation Steps</h3>

<ul>
  <li>Download the Adafruit DHT Sensor library from GitHub.</li>
  <li>Extract the downloaded library.</li>
  <li>
    Install the library by running the following command:
  </li>
</ul>

<div
  style={{
    backgroundColor: "#f4f4f4",
    padding: "10px",
    borderRadius: "8px",
    display: "inline-block",
    marginBottom: "15px"
  }}
>
  <code>sudo python setup.py install</code>
</div>

<p>
  After installation, open the example file <strong>simpletest</strong> 
  from the examples folder.
</p>

<p>
  By default, the program reads and displays the values only once. 
  It can be modified to print values continuously on the terminal.
</p>

<h3>Important Notes</h3>

<ul>
  <li>
    Assign the correct sensor type:
    <div style={{ marginTop: "5px" }}>
      <code>sensor = Adafruit_DHT.DHT11</code>
    </div>
  </li>

  <li>
    If using DHT22, change to:
    <div style={{ marginTop: "5px" }}>
      <code>sensor = Adafruit_DHT.DHT22</code>
    </div>
  </li>

  <li>
    Comment out Beaglebone pin configuration and enable Raspberry Pi pin settings.
  </li>

  <li>
    Connect the data pin of DHT11 to GPIO4 on Raspberry Pi.
  </li>
</ul>

<h3>DHT11 Python Program for Raspberry Pi</h3>

<div
  style={{
    backgroundColor: "#f4f4f4",
    padding: "15px",
    borderRadius: "10px",
    maxHeight: "400px",
    overflowY: "scroll",
    border: "1px solid #ccc",
  }}
>
  <pre style={{ margin: 0 }}>
{`#!/usr/bin/python

# Copyright (c) 2014 Adafruit Industries
# Author: Tony DiCola

import Adafruit_DHT

# Sensor selection
sensor = Adafruit_DHT.DHT11

# Raspberry Pi GPIO pin
pin = 4

while True:
    humidity, temperature = Adafruit_DHT.read_retry(sensor, pin)
    print('Temp={0:0.1f}*C  Humidity={1:0.1f}%'.format(temperature, humidity))
`}
  </pre>
</div>

<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/331/description/DHT11%20Interfacing%20with%20Raspberry%20Pi%201(0).jpg"
  alt="DHT11 Wiring Connections"
  style={{
    width: "600px",
    margin: "20px 0",
    borderRadius: "10px",
    display: "block"
  }}
/>

<h2>DHT11 Output</h2>


<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/331/description/DHT11%20output.png"
  alt="DHT11 Wiring Connections"
  style={{
    width: "600px",
    margin: "20px 0",
    borderRadius: "10px",
    display: "block"
  }}
/>
    </div>
  );
}

export default DHT11Sensor;